namespace Nobox.Administration {
    export interface ResSubscription {
        Statistik?: Nobox.StatistikRow[];
        OrderHistory?: Web.Modules.Administration.Tenant.Berlangganan[];
    }
}
